<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="LogList">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ LogList.length - currentPage
              * itemsPerPage > 0 ? currentPage * itemsPerPage : LogList.length }} of {{ LogList.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="LogActionDescription">{{ $t('LogActionDescription') }}</vs-th>
        <vs-th sort-key="UserName">{{ $t('UserName') }}</vs-th>
        <vs-th sort-key="SectionNameEn">{{ $t('SectionName') }}</vs-th>
        <vs-th sort-key="CreatedDate">{{ $t('CreatedDate') }}</vs-th>
        <vs-th sort-key="CreatedDate">{{ $t('Time') }}</vs-th>
        <vs-th sort-key="ActionNameAr">{{ $t('ActionType') }}</vs-th>

      </template>
      <template slot-scope="{data}">
        <tbody>
          <tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <!-- mainData -->
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.LogActionDescription }}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.CreatedByName.UserName }}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.SectionsTable.SectionNameEn }}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.CreatedDate.split("T")[0] }}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.CreatedDate.split("T")[1] }}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.ActionType.ActionNameAr }}</p>
            </vs-td>
          </tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>

import modulelogAction from "@/store/logAction/modulelogAction.js";
export default {
  components: {

  },
  data() {
    return {
      selected: [],
      itemsPerPage: 10,
      isMounted: false,
      LogList: [],
    };
  },
  computed: {
    currentPage() {
      debugger
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },

  methods: {
  },

  created() {

    if (!modulelogAction.isRegistered) {
      this.$store.registerModule("logActionList", modulelogAction);
      modulelogAction.isRegistered = true;
    }
    this.$store.dispatch("");

    this.$store.dispatch("logActionList/fetchDataListItems").then(res => {
      if (res.data != null) {
        this.LogList = res.data;
        debugger
      }
    });

  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
